import { render, staticRenderFns } from "./linkPriceRequest.vue?vue&type=template&id=22c4bcf8&"
import script from "./linkPriceRequest.vue?vue&type=script&lang=js&"
export * from "./linkPriceRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports